<template>
    <div class="border-l border-r border-gray-200">
        <contracted-works-changes v-for="section in sectionData"
                                  :key="section.id"
                                  :search="search"
                                  :section="section"
                                  :contract="contract"
                                  @editBuildup="(i) => $emit('editBuildup',i)"
                                  :currently-building="currentlyBuilding"
                                  :current-viewing="currentViewing"
                                  :readonly="true"
                                  :show-item-progress="showItemProgress"
                                  :show-omitted="true"
                                  :operations="operations"
        ></contracted-works-changes>
    </div>
</template>

<script>
import {cloneDeep} from "lodash";
import ContractedWorksSection from "./ContractedWorksSection.vue";

export default {
    components: {
        ContractedWorksSection
    },
    props: {
        contract: Object,
        search: '',
        operations: [],
        showItemProgress: Boolean,
        currentlyBuilding: false,
        currentViewing: false,
    },
    data() {
        return {}
    },
    computed: {
        sectionData() {
            let sections = [];
            let findSectionInContract = (sectionId) => {
                if (sectionId === 'Preliminaries') {
                    return {id: 'Preliminaries', name: 'Preliminaries', tasks: this.contract.preliminaries}
                } else {
                    return this.contract.scopeOfWorks.find((x) => x.id === sectionId);
                }
            }
            let findTaskInContract = (sectionId, taskId) => {
                let s = findSectionInContract(sectionId)
                return s ? s.tasks.find((x) => x.id === taskId) : false
            }

            let findItemInContract = (sectionId, taskId, itemId) => {
                let t = findTaskInContract(sectionId, taskId)
                return t ? t.items.find((x) => x.id === itemId) : false
            }

            let addSection = (sectionId) => {
                if (!sections.find((x) => x.id === sectionId)) {
                    let section = findSectionInContract(sectionId)
                    section = section ? cloneDeep(section) : {id: sectionId}
                    section.tasks = [];
                    sections.push(section);
                }
                return sections.find((x) => x.id === sectionId);
            }

            let addTask = (sectionId, taskId) => {
                let s = addSection(sectionId)
                if (!s.tasks.find((x) => x.id === taskId)) {
                    let task = findTaskInContract(sectionId, taskId)
                    task = task ? cloneDeep(task) : {id: taskId}
                    task.items = [];
                    s.tasks.push(task);
                }
                return s.tasks.find((x) => x.id === taskId);
            }

            let addItem = (sectionId, taskId, itemId) => {
                let t = addTask(sectionId, taskId)
                if (!t.items.find((x) => x.id === itemId)) {
                    let item = findItemInContract(sectionId, taskId, itemId)
                    t.items.push(item ? cloneDeep(item) : {id: itemId});
                }
                return t.items.find((x) => x.id === itemId);
            }

            this.operations.filter((i) => i.subject.type === 'Section').forEach((op) => {
                let s = addSection(op.subject.id)
                if (op.type === 'Omission') {
                    s.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    Object.assign(s, op.value)
                    s.proposedStatus = 'ADDED'
                } else {
                    Object.entries(op.value).forEach(([key, val]) => {
                        if (val.hasOwnProperty('to')) {
                            s[key] = val.to
                        }
                    });
                    s.proposedStatus = 'SUBSTITUTED'
                }
            })
            this.operations.filter((i) => i.subject.type === 'Task').forEach((op) => {
                let t = addTask(op.value.sectionId, op.subject.id)

                if (op.type === 'Omission') {
                    t.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    t.proposedStatus = 'ADDED'
                } else {
                    Object.entries(op.value).forEach(([key, val]) => {
                        if (val.hasOwnProperty('to')) {
                            t[key] = val.to
                        }
                    });
                    t.proposedStatus = 'SUBSTITUTED'
                }
            })
            this.operations.filter((i) => i.subject.type === 'Item').forEach((op) => {
                let i = addItem(op.value.sectionId, op.value.taskId, op.subject.id)

                if (op.type === 'Omission') {
                    i.proposedStatus = 'OMITTED'
                } else if (op.type === 'Addition') {
                    Object.assign(i, op.value)
                    i.proposedStatus = 'ADDED'
                } else {
                    Object.entries(op.value).forEach(([key, val]) => {
                        if (val.hasOwnProperty('to')) {
                            i[key] = val.to
                        }
                    });
                    i.proposedStatus = 'SUBSTITUTED'
                }
            })
            return sections;
        }
    },
    methods: {},
}
</script>
